import { PdfViewer } from 'modules/ats/components/PdfViewer'

import * as styles from './index.vanilla.css'

interface Props {
  url: string
  filename: string
  contentType: string
}

export const CurriculumViewer = ({ url, filename, contentType }: Props) => {
  const isPdf = contentType === 'application/pdf'
  const isImage = contentType.startsWith('image/')
  const isVideo = contentType.startsWith('video/')

  return (
    <>
      {isPdf && <PdfViewer url={url} filename={filename} initialScale="page-width" />}

      {isImage && <img src={url} className={styles.previewImage} />}

      {isVideo && (
        <video className={styles.previewVideo} controls>
          <source src={url} type={contentType} />
        </video>
      )}
    </>
  )
}
